import { InjectionToken } from "@angular/core";
import { WalletOperationsPort } from "./wallet-operations.port";

export const WALLET_OPERATIONS_PORT =
  new InjectionToken<WalletOperationsPort>("WALLET_OPERATIONS_PORT");
